import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { foreignFields, getForeignDetails } from "@/lib/permitDocuments";

export function ForeignWorkerMissingSummary({ workerId, refreshKey }: { workerId: string; refreshKey: number }) {
  const { can } = useAuth();
  const read = can("dozvola", "read");
  const [missing, setMissing] = useState<string[]>([]);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!read) return;
    let active = true;
    void getForeignDetails(workerId).then(data => {
      if (active) { setMissing(data.missing_required); setError(false); }
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [workerId, read, refreshKey]);
  if (!read || !error && !missing.length) return null;
  return <p>{error ? "Nije moguće provjeriti podatke stranca." : `Za zahtjev nedostaje: ${foreignFields.filter(([key]) => missing.includes(key)).map(([, label]) => label).join(", ")}.`} {" "}
    <Link className="inline-flex min-h-11 items-center underline" to={`/zaposlenici/${workerId}?tab=identitet#podaci-stranca`}>Dopuni u kartici Identitet</Link>
  </p>;
}
